module.exports = __webpack_public_path__ + "static/media/key-banesco.8c1665ed.svg";